import React from "react";
import DataTable from "react-data-table-component";

export default function ReportDetails(props) {
  const {
    data,
    columns,
    keyField,
    pagination,
    paginationComponentOptions,
    exportObject,
  } = props;

  // let dataList = data.map((donation) => {
  //   return (
  //     <tr key={donation.id}>
  //       {columns.map((column) => {
  //         return column.show && <td key={column.id}>{donation[column.id]}</td>;
  //       })}
  //     </tr>
  //   );
  // });
  // //End of dataList

  // const columnList = columns.map((column) => {
  //   return column.show && <th key={column.id}>{column.label}</th>;
  // });
  function convertArrayOfObjectsToCSV(array) {
    let result;

    const columnDelimiter = ",";
    const lineDelimiter = "\n";
    const keys = Object.keys(array[0]);

    result = "";
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    array.forEach((item) => {
      let ctr = 0;
      keys.forEach((key) => {
        if (ctr > 0) result += columnDelimiter;

        result += item[key];

        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }

  async function downloadCSV() {
    const link = document.createElement("a");

    let csv = convertArrayOfObjectsToCSV(exportObject);
    if (csv == null) return;

    const filename = `${props.filename}.csv`;

    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }

    link.setAttribute("href", encodeURI(csv));
    link.setAttribute("download", filename);
    link.click();
  }

  return (
    <>
      <div>
        <div className="card-body py-2 justify-content-center d-flex">
          <button
            className="btn btn-primary"
            onClick={(e) => {
              e.preventDefault();
              downloadCSV();
            }}
          >
            Export
          </button>
        </div>
        <DataTable
          columns={columns}
          data={data}
          keyField={keyField}
          striped
          highlightOnHover
          dense
          pagination={pagination}
          paginationComponentOptions={paginationComponentOptions}
        />
      </div>
    </>
  );
}
